<!-- Header -->
<div class="print-header">
    <div class="header-content">
        <div class="logo">
            @if (bandData?.bandLogo) {
            <img [src]="bandData?.bandLogo" alt="Band Logo" />
            }
        </div>
        <div class="appointment-title">
            <h1><b>{{ appointmentData?.title }}</b></h1>
            <p>{{ appointmentData?.startDate ? (appointmentData?.startDate | dynamicDate) : '' }}</p>
        </div>
    </div>
</div>

<!-- Content -->
<div class="print-container">
    <!-- Setlist title is only shown once, not repeated on each page -->
    <div class="setlist-title">
        <h1><b>{{ setlistData?.title }}</b></h1>
    </div>

    <div class="setlist-body">
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Song Title</th>
                    @if (showBpm) {
                    <th>BPM</th>
                    }
                    @if (showTuning) {
                    <th>Tuning</th>
                    }
                    <th>Dur.</th>
                    @if (showComment) {
                    <th>Comment</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (song of setlistData?.setlistSongs; track song.id; let i = $index) {
                <tr [class.even-row]="i % 2 === 1">
                    <td>{{ i + 1 }}</td>
                    <td><b>{{ song.song.title }}</b></td>
                    @if (showBpm) {
                    <td>{{ song.song.bpm || 'N/A' }}</td>
                    }
                    @if (showTuning) {
                    <td>{{ song.song.tuning || 'N/A' }}</td>
                    }
                    <td>{{ song.song.duration | durationPipe }}</td>
                    @if (showComment) {
                    <td>{{ song.song.comment || 'N/A' }}</td>
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>

<!-- Footer -->
<div class="setlist-footer">
    <p><b>Total Duration:</b> {{ setlistData?.durationSeconds | durationPipe }}</p>
</div>

<style>
    /****************************************
  * Universal Styles
  ****************************************/
    * {
        color: #000 !important;
        border-color: #000 !important;
        background: #fff;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: Arial, sans-serif;
        font-size: 18px;
        line-height: 1.8;
        background-color: #fff;
    }

    /****************************************
* Header (fixed at top)
****************************************/
    .print-header {
        position: static;
        top: 0;
        left: 0;
        right: 0;
        height: 25mm;
        /* Adjust as needed */
        background: #fff;
        padding: 10px;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .logo img {
        max-width: 400px;
        max-height: 150px;
    }

    .appointment-title {
        text-align: right;
    }

    /****************************************
* Footer (fixed at bottom)
****************************************/
    .setlist-footer {
        position: static;
        bottom: 0;
        right: 0;
        height: 15mm;
        /* Adjust as needed */
        background: #fff;
        padding: 10px;
        font-size: 20px;
        font-weight: bold;
        text-align: right;
    }

    /****************************************
* Main Container
****************************************/
    .print-container {
        width: 100%;
        max-width: 100%;
        padding: 10mm;
        /*
Enough top margin to avoid overlap by fixed header.
Enough bottom margin to avoid overlap by fixed footer.
*/
        margin-top: 0mm;
        margin-bottom: 0mm;
    }

    /****************************************
* Setlist Title (printed once)
****************************************/
    .setlist-title {
        text-align: center;
        margin-bottom: 30px;
    }

    .setlist-title h1 {
        font-size: 32px;
        font-weight: bold;
        margin: 0;
    }

    /****************************************
* Table Styles
****************************************/
    .setlist-body {
        margin-top: 20px;
    }

    /* Let table rows break across pages */
    .setlist-body table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 30px;

        /* Allow the table to break across pages without cutting off rows */
        page-break-inside: auto;
    }

    .setlist-body tr {
        page-break-inside: avoid;
        /* Don’t split a single table row across pages */
        page-break-after: auto;
    }

    .setlist-body th,
    .setlist-body td {
        border: 1px solid #000;
        /* black borders */
        padding: 12px;
        text-align: left;
    }

    .setlist-body th {
        background: #f1f1f1;
        font-weight: bold;
        font-size: 25px;
    }

    .setlist-body td:first-child,
    .setlist-body th:first-child {
        text-align: center;
        font-weight: bold;
        font-size: 25px;
    }

    .setlist-body td:nth-child(2),
    .setlist-body th:nth-child(2) {
        font-weight: bold;
        font-size: 25px;
    }

    .setlist-body td:nth-child(6),
    .setlist-body th:nth-child(6) {
        width: 30%;
        word-wrap: break-word;
    }

    /* Alternate row coloring */
    .setlist-body tr.even-row td {
        background-color: #e0e0e0 !important;
    }

    /****************************************
* Print-specific Rules
****************************************/
    @media print {
        @page {
            size: A4;
            margin: 10mm;
        }

        /*
Let the container break across pages naturally,
so multiple pages won't overlap the header & footer.
*/
        .print-container {
            page-break-after: auto;
        }
    }
</style>
